import { Component, EventEmitter, Input, Output } from '@angular/core'

import { MultiSelectMode, SelectedTagType } from '../../../types/filter.type'

/**
 * Выбранные теги фильтра: чипы с удалением и переключатель И/ИЛИ.
 * Сам поиск тега остаётся в bmcore-search-tag-input — здесь только выбранное.
 */
@Component({
  selector: 'bmcore-selected-tags',
  templateUrl: './bmcore-selected-tags.component.html',
  styleUrls: ['./bmcore-selected-tags.component.scss'],
  standalone: false
})
export class BmcoreSelectedTagsComponent {
  @Input() tags: SelectedTagType[] = []
  @Input() mode: MultiSelectMode = 'and'
  @Input() andLabel: string
  @Input() orLabel: string
  @Input() removeLabel: string

  @Output() removeTagEvent = new EventEmitter<number>()
  @Output() changeModeEvent = new EventEmitter<MultiSelectMode>()

  get isModeToggleVisible(): boolean {
    return this.tags?.length > 1
  }

  changeMode(mode: MultiSelectMode) {
    if (this.mode !== mode) {
      this.changeModeEvent.emit(mode)
    }
  }
}
